'use client';

import { ReelHashtags } from '@insta-club/models';
import { cn } from '@insta-club/utilities';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import Collapse from '../collapse';

interface Props {
    text: string;
    isExpanded: boolean;
    onExpanded?: (expanded: boolean) => void;
    hashtags?: ReelHashtags[];
}

const ReelsDescription: React.FC<Props> = ({ text, isExpanded, onExpanded, hashtags }) => {
    const textRef = useRef<HTMLSpanElement | null>(null);
    const [expanded, setExpanded] = useState(isExpanded);
    const [textHeight, setTextHeight] = useState(0);

    useLayoutEffect(() => {
        setTextHeight(textRef.current ? textRef.current.getBoundingClientRect().height : 0);
    }, []);

    useEffect(() => {
        setExpanded(isExpanded);
    }, [isExpanded]);

    const handleExpanded = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        const newExpanded = !expanded;
        setExpanded(newExpanded);
        onExpanded?.(newExpanded);
    };

    return textHeight > 40 ? (
        <div className='flex flex-col items-start' onClick={handleExpanded}>
            <Collapse open={expanded} collapsedSize={20}>
                <span ref={textRef} className='text-xs leading-relaxed'>
                    {text}
                </span>
                <HashtagsBox hashtags={hashtags} className='mt-2' />
            </Collapse>
            <span className='cursor-pointer pt-2 text-xs text-gray-400'>{!expanded ? 'نمایش بیشتر ...' : 'بستن'}</span>
        </div>
    ) : (
        <>
            <span className='text-xs leading-relaxed' ref={textRef}>
                {text}
            </span>
            <HashtagsBox hashtags={hashtags} />
        </>
    );
};

interface HashtagsBoxProps {
    hashtags?: ReelHashtags[];
    className?: string;
}

const HashtagsBox: React.FC<HashtagsBoxProps> = ({ hashtags, className }) => {
    if (!hashtags || hashtags.length == 0) return null;

    return (
        <div className={cn('flex flex-wrap gap-1.5', className)}>
            {hashtags?.map((hashtag, index) => {
                return (
                    <span key={`fil-${index}`} className='text-primary-200 text-xs'>
                        #{hashtag.tag}
                    </span>
                );
            })}
        </div>
    );
};

export default ReelsDescription;

